module.exports = __webpack_public_path__ + "static/costs-2017.25961513.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/exhibit5/costs-2017.png
// module id = 1392
// module chunks = 140525810354349